import {
  toolFailureMessage,
  type StoredGeneration,
} from '@/lib/tool-generations'

export function FailedToolRuns({ runs }: { runs: StoredGeneration[] }) {
  if (runs.length === 0) return null
  return (
    <section className="mt-6 space-y-3" aria-label="Failed generation history">
      <h3 className="text-sm font-medium">Recent failed runs</h3>
      {runs.slice(0, 12).map(run => (
        <details
          key={run.requestId}
          className="border-border bg-muted/20 rounded-lg border p-3 text-sm"
        >
          <summary className="cursor-pointer">
            {run.failure?.message ?? 'Generation failed'} ·{' '}
            <time dateTime={run.createdAt}>
              {new Date(run.createdAt).toLocaleString()}
            </time>
          </summary>
          <p className="text-muted-foreground mt-3 break-words whitespace-pre-wrap">
            {toolFailureMessage(
              run.failure,
              run.deliveryMode,
              run.requestId,
              true,
            )}
          </p>
        </details>
      ))}
    </section>
  )
}
